import React from "react";

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CardActions from "@material-ui/core/CardActions/CardActions";

import {
  apollo_useStyles,
  getDialogStyle,
  Option,
} from "../../atom/Apollo_styles_Beta";
import { ApolloLabel } from "../../atom/Apollo_Label";
import {
  REPORT_OUTPUT_COLUMNS,
  REPORT_KIND,
  OUTPUT_CASE_LEBEL,
  UNDER_SCORE,
  COMMA,
  ZERO,
} from "../../common/Apollo_CommonConst_Beta";
import {
  ReportSetting,
} from "../../pages/REPORT/ReportModel"

type ApolloOutputColumnDialogProps = {
  reportKind: number,
  outputCaseLebel: number,
  outputColumn: string,
  outputColumnsMaster: Option[],
  setPoints: Option[],
  deletedSetPoints: Option[],
  report: ReportSetting,
  setReport: any,
  handleClose: any,
}

const selectOutputColumns = (reportKind: number, outputCaseLebel: number): number[] => {
  switch (reportKind) {
    case REPORT_KIND.PERFORMANCE:
      switch (outputCaseLebel) {
        case OUTPUT_CASE_LEBEL.CAMPAIGN:
          return REPORT_OUTPUT_COLUMNS.CAMPAIGN;
        case OUTPUT_CASE_LEBEL.ADGROUP:
          return REPORT_OUTPUT_COLUMNS.ADGROUP;
        default:
          return REPORT_OUTPUT_COLUMNS.ADVERTISEMENT;
      }
    default:
      return (outputCaseLebel === OUTPUT_CASE_LEBEL.CAMPAIGN) ? REPORT_OUTPUT_COLUMNS.DEMOGRAPHIC_CAMPAIGN : REPORT_OUTPUT_COLUMNS.DEMOGRAPHIC_ADGROUP;
  }
};

const generateOutputColumns = (reportKind: number, outputCaseLebel: number, outputColumnsMaster: Option[]): Option[] => {
  const selectedOutputColumnIds = selectOutputColumns(reportKind, outputCaseLebel)
  const columnOptions: Option[] = [];
  for (const columnId of selectedOutputColumnIds) {
    let columnMaster = outputColumnsMaster.find((v) => v.value === columnId);
    if (columnMaster) {
      columnOptions.push(columnMaster);
    }
  }

  return columnOptions
};

const generateMasterColumns = (outputColumnsMaster: Option[]): Option[] => {
  const columnOptions: Option[] = [];
  for (const columnId of REPORT_OUTPUT_COLUMNS.MASTER) {
    let columnMaster = outputColumnsMaster.find((v) => v.value === columnId);
    if (columnMaster) {
      columnOptions.push(columnMaster);
    }
  }

  return columnOptions
};

export const filterOutputColumns = (outputColumn: string, reportKind: number, outputCaseLebel: number): string => {
  const outputColumns = outputColumn.split(COMMA);
  const selectedOutputColumnIds = selectOutputColumns(reportKind, outputCaseLebel)
  const filteredOutputColumns: string[] = [];
  for (const value of outputColumns) {
    const num = parseInt(value);
    if (selectedOutputColumnIds.includes(num) || value.includes(UNDER_SCORE)) {
      filteredOutputColumns.push(value);
    }
  }

  return filteredOutputColumns.join(COMMA)
};

export const resetOutputColumns = (outputColumn: string, reportKind: number, outputCaseLebel: number): string => {
  const outputColumns = outputColumn.split(COMMA);
  const selectedOutputColumnIds = selectOutputColumns(reportKind, outputCaseLebel)
  const resetedOutputColumns: string[] = [];
  for (const columnId of REPORT_OUTPUT_COLUMNS.MASTER) {
    if (!selectedOutputColumnIds.includes(columnId) || outputColumns.includes(String(columnId))) {
      resetedOutputColumns.push(String(columnId));
    } else if (REPORT_OUTPUT_COLUMNS.SETPOINT.includes(columnId)) {
      const filteredItems = outputColumns.filter(item => item.startsWith(`${columnId}${UNDER_SCORE}`));
      if (filteredItems.length > 0) {
        resetedOutputColumns.push(...filteredItems);
      }
    }
  }

  return resetedOutputColumns.join(COMMA)
};

export const isSetOutputColumns = (outputColumn: string, reportKind: number, outputCaseLebel: number): boolean => {
  const outputColumns = outputColumn.split(COMMA);
  const selectedOutputColumnIds = selectOutputColumns(reportKind, outputCaseLebel)
  for (const columnId of selectedOutputColumnIds) {
    if (!outputColumns.includes(String(columnId))) {
      return true
    }
  }

  return false
};

export const ApolloOutputColumnDialog = ({
  reportKind,
  outputCaseLebel,
  outputColumn,
  outputColumnsMaster,
  setPoints,
  deletedSetPoints,
  report,
  setReport,
  handleClose,
}: ApolloOutputColumnDialogProps) => {

  const masterColumns = generateMasterColumns(outputColumnsMaster);
  const columns = generateOutputColumns(reportKind, outputCaseLebel, outputColumnsMaster);
  const outputColumnJson = outputColumn.split(COMMA);

  const classes = apollo_useStyles();
  const [checkedList, setCheckedList] = React.useState(masterColumns.map((column, index) => outputColumnJson.includes(String(column.value))));
  const [setpointCheckedList, setSetpointCheckedList] = React.useState(masterColumns.map((column, index) => setPoints.map((v) => outputColumnJson.includes(String(column.value)) || outputColumnJson.includes(`${column.value}${UNDER_SCORE}${v.value}`))));
  const [deletedSetpointCheckedList, setDeletedSetpointCheckedList] = React.useState(masterColumns.map((column, index) => deletedSetPoints.map((v) => outputColumnJson.includes(String(column.value)) || outputColumnJson.includes(`${column.value}${UNDER_SCORE}${v.value}`))));

  const setOutputColumn = (newCheckedList: boolean[], newSetpointCheckedList: boolean[][], newDeletedSetpointCheckedList: boolean[][]) => {
    const local_output_column: string[] = [];
    masterColumns.forEach((column, i: number) => {
      if (newCheckedList[i]) {
        local_output_column.push(String(column.value));
      } else if (REPORT_OUTPUT_COLUMNS.SETPOINT.includes(column.value)) {
        for (var index = ZERO; index < setPoints.length; index++) {
          if (newSetpointCheckedList[i][index]) {
            var value = `${column.value}${UNDER_SCORE}${setPoints[index].value}`
            if (!local_output_column.includes(value)) {
              local_output_column.push(value);
            }
          }
        }

        for (var index = ZERO; index < deletedSetPoints.length; index++) {
          if (newDeletedSetpointCheckedList[i][index]) {
            var value = `${column.value}${UNDER_SCORE}${deletedSetPoints[index].value}`
            if (!local_output_column.includes(value)) {
              local_output_column.push(value);
            }
          }
        }
      }
    });
    setReport({ ...report, outputColumn: local_output_column.join(COMMA) })
  };

  const handleChangeColumnChecked = (index: number) => {
    const newCheckedList = [...checkedList];
    newCheckedList[index] = !newCheckedList[index];
    setCheckedList(newCheckedList);

    const newSetpointCheckedList = [...setpointCheckedList];
    const newDeletedSetpointCheckedList = [...deletedSetpointCheckedList];
    setOutputColumn(newCheckedList, newSetpointCheckedList, newDeletedSetpointCheckedList);
  };

  const handleChangeSetpointColumnChecked = (index: number) => {
    const newCheckedList = [...checkedList];
    newCheckedList[index] = !newCheckedList[index];
    setCheckedList(newCheckedList);

    const newSetpointCheckedList = [...setpointCheckedList];
    newSetpointCheckedList[index].map((_, idx) => newSetpointCheckedList[index][idx] = newCheckedList[index]);
    setSetpointCheckedList(newSetpointCheckedList);

    const newDeletedSetpointCheckedList = [...deletedSetpointCheckedList];
    newDeletedSetpointCheckedList[index].map((_, idx) => newDeletedSetpointCheckedList[index][idx] = newCheckedList[index]);
    setDeletedSetpointCheckedList(newDeletedSetpointCheckedList);

    setOutputColumn(newCheckedList, newSetpointCheckedList, newDeletedSetpointCheckedList);
  };

  const handleChangeSetpointsChecked = (columnIdx: number, setpointIdx: number) => {
    const newSetpointCheckedList = [...setpointCheckedList];
    newSetpointCheckedList[columnIdx][setpointIdx] = !newSetpointCheckedList[columnIdx][setpointIdx];
    setSetpointCheckedList(newSetpointCheckedList);

    const newCheckedList = [...checkedList];
    if (!setpointCheckedList[columnIdx].includes(false) && !deletedSetpointCheckedList[columnIdx].includes(false)) {
      newCheckedList[columnIdx] = true;
      setCheckedList(newCheckedList);
    } else if (newCheckedList[columnIdx]) {
      newCheckedList[columnIdx] = false;
      setCheckedList(newCheckedList);
    }

    const newDeletedSetpointCheckedList = [...deletedSetpointCheckedList];
    setOutputColumn(newCheckedList, newSetpointCheckedList, newDeletedSetpointCheckedList);
  };

  const handleChangeDeletedSetpointsChecked = (columnIdx: number, setpointIdx: number) => {
    const newDeletedSetpointCheckedList = [...deletedSetpointCheckedList];
    newDeletedSetpointCheckedList[columnIdx][setpointIdx] = !newDeletedSetpointCheckedList[columnIdx][setpointIdx];
    setDeletedSetpointCheckedList(newDeletedSetpointCheckedList);

    const newCheckedList = [...checkedList];
    if (!setpointCheckedList[columnIdx].includes(false) && !deletedSetpointCheckedList[columnIdx].includes(false)) {
      newCheckedList[columnIdx] = true;
      setCheckedList(newCheckedList);
    } else if (newCheckedList[columnIdx]) {
      newCheckedList[columnIdx] = false;
      setCheckedList(newCheckedList);
    }

    const newSetpointCheckedList = [...setpointCheckedList];
    setOutputColumn(newCheckedList, newSetpointCheckedList, newDeletedSetpointCheckedList);
  };

  return (
    <React.Fragment>
      <Grid style={getDialogStyle()}>
        <Grid item xs={12}>
          <ApolloLabel label="出力カラム設定"/>
        </Grid>

        <Grid item xs={12} className={classes.rowStyle} style={{display: "block"}}>
            {masterColumns.map((column, index) => {
                return (
                  <React.Fragment>
                    {
                      columns.includes(column) ?
                        !REPORT_OUTPUT_COLUMNS.SETPOINT.includes(column.value) ?
                          <Box sx={{ display: 'flex', flexDirection: 'column', ml: 2 }}>
                            <FormControlLabel
                              label={column.label}
                              control={
                                <Checkbox
                                  checked={checkedList[index]}
                                  onChange={() => handleChangeColumnChecked(index)}
                                />
                              }
                            />
                          </Box>
                        : <Accordion>
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel1a-content"
                              id="panel1a-header"
                            >
                              <FormControlLabel
                                label={column.label}
                                control={
                                  <Checkbox
                                    checked={checkedList[index]}
                                    indeterminate={!checkedList[index] && (setpointCheckedList[index].includes(true) || deletedSetpointCheckedList[index].includes(true))}
                                    onChange={() => handleChangeSetpointColumnChecked(index)}
                                  />
                                }
                                onClick={(e) => e.stopPropagation()}
                              />
                            </AccordionSummary>
                            <AccordionDetails>
                              <Box sx={{ display: 'flex', flexDirection: 'column', ml: 3 }}>
                                {setPoints.map((v, idx) => (
                                  <FormControlLabel
                                    value={v.value}
                                    control={
                                      <Checkbox
                                        checked={setpointCheckedList[index][idx]}
                                        onChange={() => handleChangeSetpointsChecked(index, idx)}
                                      />
                                    }
                                    label={v.label}
                                  />
                                ))}
                              </Box>
                            </AccordionDetails>
                            <Accordion style={{ display: 'flex', flexDirection: 'column', marginLeft: 30, marginRight: 30, marginBottom: 30 }}>
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1b-content"
                                id="panel1b-header"
                              >
                                <Typography>削除済み測定ポイント</Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                                <Box sx={{ display: 'flex', flexDirection: 'column', ml: 3 }}>
                                  {deletedSetPoints.map((v, idx) => (
                                    <FormControlLabel
                                      value={v.value}
                                      control={
                                        <Checkbox
                                          checked={deletedSetpointCheckedList[index][idx]}
                                          onChange={() => handleChangeDeletedSetpointsChecked(index, idx)}
                                        />
                                      }
                                      label={v.label}
                                    />
                                  ))}
                                </Box>
                              </AccordionDetails>
                            </Accordion>
                          </Accordion>
                      : null
                    }
                  </React.Fragment>
                )
              }
            )
          }
        </Grid>

        <CardActions className={classes.cardActionButton}>
          <Button
            variant="contained"
            color="default"
            onClick={handleClose}
            className={classes.button}
            style={{marginBottom: "40px"}}
          >
            閉じる
          </Button>
        </CardActions>
      </Grid>
    </React.Fragment>
  );
}
